import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { UrgencyDailyPointDTO, UrgencyKpisDTO } from '../../../dto/urgencySummary/UrgencySummaryDTO'
import { PeakAnalysis } from '../../ServicesStatistics/peaks'
import { averageArrivalsPerDay, hasArrivals, UrgencyMeasure, waitPeaks } from '../urgencyAnalysis'
import { formatCount } from '../urgencySummaryFormat'
import UrgencyPeakChips from './UrgencyPeakChips'
import UrgencyTimelineChart from './UrgencyTimelineChart'

interface UrgencyEvolutionProps {
  daily: UrgencyDailyPointDTO[]
  measure: UrgencyMeasure
  ariaLabel: string
  /** Los indicadores del período: de ahí sale el promedio ponderado de la espera (el mismo número del indicador). */
  current: UrgencyKpisDTO
  /** Abre el detalle de un día con llegadas; `opener` es a donde vuelve el foco al cerrar el panel. */
  onOpenDay: (day: UrgencyDailyPointDTO, opener: HTMLElement | null) => void
}

/**
 * El gráfico de evolución con su línea de promedio y, con la espera, los picos marcados y los chips «Picos» que abren el
 * detalle de cada uno. Con «Llegadas» no hay picos: el fin de semana bajo y el lunes alto son el patrón de la semana. Los
 * días sin llegadas no se dibujan: si hay, una nota lo dice.
 */
export default function UrgencyEvolution({ daily, measure, ariaLabel, current, onOpenDay }: UrgencyEvolutionProps) {
  const intl = useIntl()
  const analysis = useMemo<PeakAnalysis | null>(() => (measure === 'wait' ? waitPeaks(daily) : null), [daily, measure])
  const average = measure === 'arrivals' ? averageArrivalsPerDay(daily) : current.avgWaitMinutes
  const emptyDays = daily.filter((day) => !hasArrivals(day)).length

  return (
    <div className="nv-urg-evolution">
      <UrgencyTimelineChart daily={daily} measure={measure} ariaLabel={ariaLabel} average={average} analysis={analysis} onOpen={onOpenDay} />
      {analysis && <UrgencyPeakChips daily={daily} analysis={analysis} onOpen={onOpenDay} />}
      {emptyDays > 0 && (
        <p className="nv-help">
          {intl.formatMessage({ id: 'UrgencySummaryEvolutionNoDays' }, { count: emptyDays, countText: formatCount(intl, emptyDays) })}
        </p>
      )}
    </div>
  )
}
